import { notification, Popconfirm, Space } from "antd";
import React from "react";
import TmsThulabharamService from "../../../services/tms-thulabharam.service";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import tmsRouteMap from "../../../constants/tms-route.map";

const TmsThulabharamInnerActions = ({
  record,
  setLoading,
  setViewThulabharamData,
  settmsModalVisible,
  setUpdateFlag,
  setEditFlag,
  setProductId,
  router,
  setShowDrawer,
  setTermsData,
}) => {
  return (
    <Space size="middle">
      <a
        onClick={() => {
          router.navigate(
            `${tmsRouteMap.sm_thulabharam_manage_counter}?id=${record.key}`
          );
        }}
      >
        Manage POS
      </a>
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const data = await TmsThulabharamService.viewThulabharam(
              record?.key
            );
            // console.log(darData);
            setViewThulabharamData(data);
            settmsModalVisible(true);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EyeOutlined />
      </a>
      <Popconfirm
        title="Are you sure delete this thulabharam?"
        onConfirm={async () => {
          setLoading(true);
          try {
            await TmsThulabharamService.deleteThulabharam(record?.key);
            notification.success({
              message: "Thulabharam Deleted Successful",
            });
            setUpdateFlag(Math.random() * 100);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
        okText="Yes"
        cancelText="No"
      >
        <a>
          <DeleteOutlined />
        </a>
      </Popconfirm>
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const darData = await TmsThulabharamService.viewThulabharam(
              record?.key
            );
            setViewThulabharamData(darData);
            settmsModalVisible(true);
            setEditFlag(true);
            setProductId(record?.key);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EditOutlined />
      </a>
      <a
        onClick={() => {
          setShowDrawer(true);
          setProductId(record?.key);
          setTermsData(record?.metadata?.termsAndConditions);
        }}
      >
        <FileProtectOutlined />
      </a>
    </Space>
  );
};
export default withRouter(TmsThulabharamInnerActions);
